import { CustomType } from "../../../../../types";
import mainCss from "../kpmg_au_pptx_preview.module.scss";
import css from "./custom_field.module.scss";

type CustomTypeProps = { customType: CustomType };

export const CustomField = ({ customType }: CustomTypeProps) => {
  const values = customType.text ? customType.text.split("\r ") : [];

  if (values.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={mainCss.header2}>{customType.type.display_as}</div>
      <ul className={css.list}>
        {values.map((item) => (
          <li key={item} className={mainCss.sidebarBullet}>
            <span className={css.item}>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
